/*
 * @Author: long
 * @Date: 2022-03-14 16:09:39
 * @LastEditTime: 2022-12-01 13:44:08
 * @LastEditors: long
 * @Description:
 * @FilePath: /website/Users/long/Documents/workspace/portal/src/permission.js
 *
 */
import NProgress from "nprogress";
import { getToken, removeToken } from "components/utils/auth";
import { getCookies } from "@/utils";

import router from "@/router";
const whiteList = ["/login", "/password", "/applyNotice", "/application"];
const loginRoutePath = "/login";
router.beforeEach((to, from, next) => {
  NProgress.start({ showSpinner: false });
  // dev ifram嵌入规避 Cookies.set("SameSite", "Strict");
  const cooke = window.self === window.top ? getCookies() : true;
  if (!(getToken() && cooke)) {
    removeToken();
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next({ path: loginRoutePath });
    }
  } else {
    next();
  }
});
router.afterEach(() => {
  NProgress.done();
});
